export default "__VITE_ASSET__DfXyLjiA__"